import React from "react";
import ArrowImg from "../../Assets/images/icons/arrow-down.png";
const CustomArrowSVG = () => {
  return (
    <img
      src={ArrowImg}
      alt="arrow"
      style={{ width: "14px", height: "14px", transform: "rotate(0deg)" }}
    />
  );
};

export default CustomArrowSVG;
